import { useRfqAccess } from '@forgd/liquidity.forgd.com/layers/rfq/composables/useRfqAccess'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) {
    return
  }

  const hasRfqAccess = useRfqAccess()
  if (!hasRfqAccess.value) {
    return navigateTo('/active-rfqs')
  }
})
